import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	loadingItemAriaLabel: {
		id: 'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label',
		description:
			'Additional context after the label text for screen reader users when an item is loading',
		defaultMessage: '(loading)',
	},
});
